import type { Row } from '@tanstack/react-table';
import { WizerConnectorStatus } from '../../hooks/useGetWizerConnectorStatus';
import { ServiceStatus } from '../../types';
import type { ServiceStatusInfo } from '../../types';
import { ProductFamilyCode } from '../../types';

export const shouldDisplayTrainingButton = ({
  row,
  wizerConnectorStatus,
  isEligibleForFreeCtaas,
}: {
  row: Row<ServiceStatusInfo>;
  wizerConnectorStatus: WizerConnectorStatus;
  isEligibleForFreeCtaas: boolean;
}) => {
  if (row.original.productFamily?.code !== ProductFamilyCode.CTS) {
    return false;
  }

  if (wizerConnectorStatus === WizerConnectorStatus.Activated) {
    return true;
  }

  if (isEligibleForFreeCtaas) {
    return true;
  }

  if (row.original.status === ServiceStatus.Activated) {
    return true;
  }

  return false;
};
